import script from "./tb_header.vue?vue&type=script&lang=ts&setup=true"
export * from "./tb_header.vue?vue&type=script&lang=ts&setup=true"

import "./tb_header.vue?vue&type=style&index=0&id=05ccb803&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ccb803"]])

export default __exports__